<template>
  <div class="login-container">
    <!-- 云朵背景 -->
    <div class="clouds">
      <div class="cloud x1"></div>
      <div class="cloud x2"></div>
      <div class="cloud x3"></div>
      <div class="cloud x4"></div>
      <div class="cloud x5"></div>
    </div>
    
    <el-card class="login-card">
      <div class="title">
        <i class="el-icon-plane title-icon"></i>
        长空杯比赛报名系统
      </div>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="登录" name="login">
          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0px">
            <el-form-item prop="phone">
              <el-input v-model="loginForm.phone" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" placeholder="请输入密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleLogin" style="width: 100%">登录</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        
        <el-tab-pane label="注册" name="register">
          <el-form :model="registerForm" :rules="registerRules" ref="registerForm" label-width="0px">
            <el-form-item prop="phone">
              <el-input v-model="registerForm.phone" prefix-icon="el-icon-mobile-phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input v-model="registerForm.password" prefix-icon="el-icon-lock" type="password" placeholder="请输入密码（包含大小写字母和数字）"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword">
              <el-input v-model="registerForm.confirmPassword" prefix-icon="el-icon-lock" type="password" placeholder="请确认密码"></el-input>
            </el-form-item>
            <el-form-item prop="email">
              <el-input v-model="registerForm.email" prefix-icon="el-icon-message" placeholder="请输入邮箱"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleRegister" style="width: 100%">注册</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    // 手机号验证
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的11位手机号'))
      } else {
        callback()
      }
    }

    // 密码验证
    const validatePassword = (rule, value, callback) => {
      const passwordReg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (!passwordReg.test(value)) {
        callback(new Error('密码必须包含大小写字母和数字，长度8-20位'))
      } else {
        callback()
      }
    }

    // 确认密码验证
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请确认密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      activeTab: 'login',
      loginForm: {
        phone: '',
        password: ''
      },
      registerForm: {
        phone: '',
        password: '',
        confirmPassword: '',
        email: ''
      },
      loginRules: {
        phone: [
          { required: true, trigger: 'blur', validator: validatePhone }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ]
      },
      registerRules: {
        phone: [
          { required: true, trigger: 'blur', validator: validatePhone }
        ],
        password: [
          { required: true, trigger: 'blur', validator: validatePassword }
        ],
        confirmPassword: [
          { required: true, trigger: 'blur', validator: validateConfirmPassword }
        ],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClick(tab) {
      this.activeTab = tab.name
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          // TODO: 实现登录逻辑
          this.$message.success('登录成功')
        }
      })
    },
    handleRegister() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          // TODO: 实现注册逻辑
          this.$message.success('注册成功')
        }
      })
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(to bottom, #87CEEB, #E0FFFF);
  position: relative;
  overflow: hidden;
}

/* 云朵样式 */
.clouds {
  position: absolute;
  width: 100%;
  height: 100%;
}

.cloud {
  width: 200px;
  height: 60px;
  background: #fff;
  border-radius: 200px;
  position: absolute;
  animation: float linear infinite;
  opacity: 0.8;
}

.cloud:before,
.cloud:after {
  content: '';
  position: absolute;
  background: #fff;
  width: 100px;
  height: 80px;
  top: -15px;
  border-radius: 100px;
}

.cloud:after {
  width: 120px;
  height: 120px;
  top: -55px;
  left: 50px;
}

.x1 {
  left: -200px;
  top: 15%;
  transform: scale(0.6);
  animation-duration: 45s;
  animation-delay: 0s;
}

.x2 {
  left: -200px;
  top: 25%;
  transform: scale(0.8);
  animation-duration: 40s;
  animation-delay: 5s;
}

.x3 {
  left: -200px;
  top: 50%;
  transform: scale(0.5);
  animation-duration: 35s;
  animation-delay: 10s;
}

.x4 {
  left: -200px;
  top: 70%;
  transform: scale(0.7);
  animation-duration: 50s;
  animation-delay: 15s;
}

.x5 {
  left: -200px;
  top: 85%;
  transform: scale(0.6);
  animation-duration: 45s;
  animation-delay: 20s;
}

@keyframes float {
  from {
    left: -200px;
  }
  to {
    left: calc(100% + 200px);
  }
}

.login-card {
  width: 400px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
}

.title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
  color: #4A90E2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-icon {
  margin-right: 10px;
  font-size: 28px;
  color: #4A90E2;
}

/* 表单样式优化 */
.el-input {
  margin-bottom: 15px;
}

.el-input__inner {
  border-radius: 25px;
  height: 45px;
  border: 1px solid #e8e8e8;
  transition: all 0.3s ease;
}

.el-input__inner:focus {
  border-color: #4A90E2;
  box-shadow: 0 0 8px rgba(74, 144, 226, 0.2);
}

/* 按钮样式 */
.el-button {
  border-radius: 25px;
  height: 45px;
  font-size: 16px;
  background: linear-gradient(135deg, #4A90E2, #357ABD);
  border: none;
  transition: all 0.3s ease;
}

.el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(74, 144, 226, 0.3);
  opacity: 0.9;
}

/* 标签页样式 */
.el-tabs__item {
  color: #666;
  font-size: 16px;
}

.el-tabs__item.is-active {
  color: #4A90E2;
}

.el-tabs__active-bar {
  background-color: #4A90E2;
}
</style> 